import { readStates, saveStates } from '@/constants/lifecycle';

const configurationActions = {
  APPLY_CONFIGURATIONS: 'APPLY_CONFIGURATIONS',
  FETCH_CONFIGURATION: 'FETCH_CONFIGURATION',
  HIDE_AUTO_APPROVAL_CONFIGURATION: 'HIDE_AUTO_APPROVAL_CONFIGURATION',
  SHOW_AUTO_APPROVAL_CONFIGURATION: 'SHOW_AUTO_APPROVAL_CONFIGURATION',
  SHOW_CONFIGURATION_SUCCESS: 'SHOW_CONFIGURATION_SUCCESS',
  SHOW_CONFIGURATION_ERROR: 'SHOW_CONFIGURATION_ERROR',
  TOGGLE_AUTO_APPROVAL_CONFIGURATION: 'TOGGLE_AUTO_APPROVAL_CONFIGURATION',
  UPDATE_CONFIGURATION_ERROR: 'UPDATE_CONFIGURATION_ERROR',
  UPDATE_CONFIGURATION_PROPERTIES: 'UPDATE_CONFIGURATION_PROPERTIES',
  UPDATE_CONFIGURATION_SUCCESS: 'UPDATE_CONFIGURATION_SUCCESS',
  UPDATE_DEFAULT_ROLE_CONFIGURATION: 'UPDATE_DEFAULT_ROLE_CONFIGURATION',
};

export const configurationCodes = {
  DEFAULT_APPROVAL: 'default-approved',
  DEFAULT_CATALOGUE: 'default-catalogue-definition',
  DEFAULT_ROLE: 'default-role',
  DEFAULT_SEARCH_CONFIG: 'default-search-config',
  WORKFLOW_TASK_LIST: 'enable-workflow-task-list-link',
};

export const configurationStates = {
  ...readStates,
  ...saveStates,
};

export default configurationActions;
